import FlagImage from './FlagImage';

export default FlagImage;
